const brazeState = new Map<'initialized', boolean>()

export const brazeInitialized = (): boolean =>
  brazeState.get('initialized') || false

export const setBrazeInitialized = (initialized: boolean) =>
  brazeState.set('initialized', initialized)
